import {useBleskAuth} from '@blesk-frontend/auth';
import {useMemo} from 'react';

/**
 *
 */
export const useTeamStaff = () => {
  const {
    query: {data: user, isLoading, refetch},
    teamId,
  } = useBleskAuth();

  const staff = useMemo(
    () => user?.teams.find((team) => team.team.id === teamId)?.team.staff?.at(0)?.staff,
    [user, teamId],
  );

  return {staff, isLoading, refetch};
};
